export default __webpack_public_path__ + "static/media/karin.8ff54844.png";